"use strict";

var _interopRequireWildcard = require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/interopRequireWildcard.js").default;
var _interopRequireDefault = require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ImageDocumentPreview = void 0;
var _regeneratorRuntime2 = _interopRequireDefault(require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js"));
var _asyncToGenerator2 = _interopRequireDefault(require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js"));
var _slicedToArray2 = _interopRequireDefault(require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray.js"));
var _ModalBase = require("../../../elements/modal-base/ModalBase");
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _imageDocumentPreviewModule = _interopRequireDefault(require("./image-document-preview.module.scss"));
var _close = require("../../../assets/icons/close.svg");
var _LoadingBlock = require("../../../elements/loading-block/LoadingBlock");
var _useTranslation2 = require("../../../hooks/useTranslation/useTranslation");
function arrayBufferToBase64(buffer) {
  var binary = '';
  var bytes = new Uint8Array(buffer);
  var len = bytes.byteLength;
  for (var i = 0; i < len; i++) {
    binary += String.fromCharCode(bytes[i]);
  }
  return window.btoa(binary);
}
var ImageError = function ImageError() {
  var _useTranslation = (0, _useTranslation2.useTranslation)(),
    t = _useTranslation.t;
  return /*#__PURE__*/_react.default.createElement("div", {
    "data-testid": "image-error",
    className: (0, _classnames.default)(_imageDocumentPreviewModule.default['image-document-preview'], _imageDocumentPreviewModule.default['image-document-preview--error'])
  }, t('imageDocumentPreview.error'));
};
var ImageDocumentPreview = function ImageDocumentPreview(_ref) {
  var file = _ref.file,
    className = _ref.className,
    authorization = _ref.authorization,
    _ref$disableModalView = _ref.disableModalView,
    disableModalView = _ref$disableModalView === void 0 ? false : _ref$disableModalView;
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    isDetailsModalOpen = _useState2[0],
    setDetailsModalOpen = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
    isLoaded = _useState4[0],
    setIsLoaded = _useState4[1];
  var _useState5 = (0, _react.useState)(false),
    _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
    hasError = _useState6[0],
    setHasError = _useState6[1];
  var _useState7 = (0, _react.useState)(''),
    _useState8 = (0, _slicedToArray2.default)(_useState7, 2),
    src = _useState8[0],
    setSrc = _useState8[1];
  (0, _react.useEffect)(function () {
    setIsLoaded(false);
    setHasError(false);
    function loadImageWithAuth() {
      return _loadImageWithAuth.apply(this, arguments);
    }
    function _loadImageWithAuth() {
      _loadImageWithAuth = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
        var requestOptions, response, binaryData, base64, contentType, data;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                requestOptions = {
                  method: 'GET',
                  headers: {
                    authorization: authorization
                  }
                };
                _context.prev = 1;
                _context.next = 4;
                return fetch(file, requestOptions);
              case 4:
                response = _context.sent;
                if (!response.ok) {
                  _context.next = 16;
                  break;
                }
                _context.next = 8;
                return response.arrayBuffer();
              case 8:
                binaryData = _context.sent;
                base64 = arrayBufferToBase64(binaryData);
                contentType = response.headers.get('Content-Type');
                data = "data:".concat(contentType, ";base64,").concat(base64);
                setSrc(data);
                setIsLoaded(true);
                _context.next = 17;
                break;
              case 16:
                setHasError(true);
              case 17:
                _context.next = 22;
                break;
              case 19:
                _context.prev = 19;
                _context.t0 = _context["catch"](1);
                setHasError(true);
              case 22:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[1, 19]]);
      }));
      return _loadImageWithAuth.apply(this, arguments);
    }
    function preloadImage() {
      var img = new Image();
      img.src = file;
      img.onload = function () {
        setSrc(file);
        setIsLoaded(true);
      };
      img.onerror = function () {
        setHasError(true);
      };
    }
    if (!authorization) {
      preloadImage();
    } else {
      loadImageWithAuth();
    }
  }, [file, authorization, src]);
  var onClick = function onClick() {
    if (isLoaded && !disableModalView) {
      setDetailsModalOpen(true);
    }
  };
  var closePreview = function closePreview() {
    return setDetailsModalOpen(false);
  };
  if (hasError) {
    return /*#__PURE__*/_react.default.createElement(ImageError, null);
  }
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, isLoaded ? /*#__PURE__*/_react.default.createElement("img", {
    "data-testid": "loaded-image",
    className: (0, _classnames.default)(_imageDocumentPreviewModule.default['image-document-preview'], className),
    src: src,
    onClick: onClick,
    onError: function onError() {
      return setHasError(true);
    }
  }) : /*#__PURE__*/_react.default.createElement(_LoadingBlock.LoadingBlock, {
    className: (0, _classnames.default)(_imageDocumentPreviewModule.default['image-document-preview'], className)
  }), /*#__PURE__*/_react.default.createElement(_ModalBase.ModalBase, {
    isOpen: isDetailsModalOpen,
    className: _imageDocumentPreviewModule.default['image-document-preview__modal'],
    close: closePreview
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: src,
    "data-testid": "image-preview",
    className: _imageDocumentPreviewModule.default['image-document-preview__preview']
  })), isDetailsModalOpen && /*#__PURE__*/_react.default.createElement(_close.ReactComponent, {
    className: _imageDocumentPreviewModule.default['image-document-preview__close-icon'],
    onClick: closePreview,
    "data-testid": "close-icon"
  }));
};
exports.ImageDocumentPreview = ImageDocumentPreview;